import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-ice px-3 py-4 sm:px-6" data-id="element-76" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-2xl items-start gap-2.5 rounded-md border-2 border-electric/40 bg-white px-3 py-2.5" data-id="element-77" data-mp="1o3dmwcdeadr5">
        <ShieldCheckIcon className="mt-0.5 h-8 w-8 shrink-0 text-electric" strokeWidth={1.6} aria-hidden="true" data-id="element-78" data-mp="1x4bsv07e8vcd" />
        <div data-id="element-79" data-mp="19ehege7feyq0">
          <h2 className="text-[0.95rem] font-black uppercase leading-tight text-navy sm:text-[1.3rem]" data-id="element-80" data-mp="19dzcd0y31qa6">
            YOUR PURCHASE IS 100% PROTECTED
          </h2>
          <p className="mt-0.5 text-[0.78rem] leading-[1.35] sm:text-[0.9rem]" data-id="element-81" data-mp="14dtg17gvbflr">
            Explore KITCHEN EQUIPMENT DIAGNOSTIC PRO™ for 7 days. Access the complete 6-module
            diagnostic system and all 5 strategic bonuses. If it isn't right for you, contact us
            within 7 days for a full refund according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}